import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { fetchWithCache } from "src/utils/cacheUtils";

interface ErrorResponse {
  detail?: string;
  message?: string;
}

export const getWaiver = async (authId, userDataPlatform, leagueIdPlatform, pocToken, accessAuthToken, signal?: AbortSignal, yahooToken?: string): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/waivers`;
    // Cache key based on league and user for better tracking
    const cacheKey = `waiver-${leagueIdPlatform}-${userDataPlatform.user_id}`;

    const requestData = {
      league_integration: {
        pocToken: pocToken,
        leagueToken: userDataPlatform.integration_name === "yahoo" ? yahooToken : userDataPlatform.token,
        user_id: userDataPlatform.user_id,
        league_id: leagueIdPlatform,
        integration_name: userDataPlatform.integration_name,
      },
      response_settings: {
        persona_input: "standard",
        // max_words: 0,
        response_type: "stories",
      },
      sport: "NFL",
      model: "RotoGPT 5.0",
    };
    // console.log("Waiver REQUEST DATA", requestData);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
        "X-Skip-Cache": "true",
      },
      body: JSON.stringify(requestData),
      signal,
    };

    const { data, fromCache, ok } = await fetchWithCache(url, options, leagueIdPlatform, userDataPlatform.user_id, authId);

    // if (fromCache) {
    //   console.log(`[Waiver Cache] HIT for: ${cacheKey}`);
    // } else {
    //   console.log(`[Waiver Cache] MISS for: ${cacheKey}`);
    // }

    if (!ok) {
      const errorData = data as ErrorResponse;
      throw new Error(errorData.detail || errorData.message);
    }

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      // Handle abort silently
      console.log("Request was aborted");
      return;
    }
    // console.error("Something went wrong when getting waiver data", error);
    // showErrorToast("Something went wrong when getting waiver data");
    // throw error;
    console.error("Error in getWaiver:", error);
    showErrorToast(error.message);
    throw error;
  }
};
